/* eslint-disable no-use-before-define */
// variable from vendor.js and pug template variables
/* global grecaptcha, appSettings, isPreview, questions, url, refererSource, skipGoogleRecapture */
/* global i18nData, datePickerI18n, isJoinTalentCommunity, Sentry */
/* eslint-disable block-scoped-var,vars-on-top,no-redeclare */
/* global FilePond, FilePondPluginFileValidateSize, FilePondPluginFileValidateType */

import _ from 'lodash';
import Pikaday from 'pikaday';
import i18next from 'i18next';

import {
  validateNRIC,
  isNumeric,
  getInputNameAttributeString,
  autoLink,
} from '../assets/js/utils';
import { isAnyFileUploading, updateSubmitButtonState } from '../utils/fileUploadState';
import { fileValidationOptions } from '../utils/fileTypes';
import { parsePhone, resolveIntlTelInputCountry } from '../utils/phone';
import { classifySubmitError, submitErrorText } from '../utils/submitErrors';
import { captureStageError } from '../utils/errorReporter';
import { CAREER_PAGE_TRACKING_EVENTS } from '../server-utils';
import { APIHOST, careerPagesGACode } from '../config';
import { initClientI18n } from '../i18n/initClientI18n';
import initDesktopAppCard from './job-page-desktop-app-card';

const { t } = i18next;

function parsePhoneField($el) {
  const countryData = $el.intlTelInput('getSelectedCountryData');
  return parsePhone($el.val(), countryData && countryData.iso2);
}

function initPhoneFields(initialCountry, preferredCountries) {
  $('.js-phone').intlTelInput({
    initialCountry,
    geoIpLookup(callback) {
      $.get('https://ipinfo.io', () => { }, 'jsonp').always((resp) => {
        const countryCode = resp && resp.country ? resp.country : '';
        callback(countryCode);
      });
    },
    preferredCountries,
  });
}

$(() => {
  if (locale && i18nData) {
    initClientI18n({
      resources: i18nData,
      lng: locale,
    });
  }

  // Date picker
  $('[data-toggle="datepicker"]').each(function initDatePicker() {
    // eslint-disable-next-line no-new
    new Pikaday({
      field: this,
      format: 'LL',
      yearRange: [1900, 2050],
      i18n: datePickerI18n,
    });
  });

  const knownIso2Codes = new Set(
    (_.get($.fn, 'intlTelInput.getCountryData', () => [])() || []).map((c) => c.iso2),
  );
  const initialCountry = resolveIntlTelInputCountry(
    _.get(window, 'position.location.country'),
    knownIso2Codes,
  );
  const preferredCountries = ['us', 'sg'];
  if (!preferredCountries.includes(initialCountry)) {
    preferredCountries.push(initialCountry);
  }

  // intTelInput component setup — never let a bad country abort the rest of page ready
  try {
    initPhoneFields(initialCountry, preferredCountries);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('intlTelInput init failed; falling back to us', err);
    initPhoneFields('us', ['us', 'sg']);
  }

  initFileFields();

  if (window.jobPageApp && window.jobPageApp.onelink) {
    initDesktopAppCard(window.jobPageApp);
  }
});

$('.js-submit-preview').click((e) => {
  // eslint-disable-next-line no-alert
  alert(
    "You can't apply on preview mode, please go to dashboard and publish this job first",
  );
  e.preventDefault();
});

// Prevent paste in non-number values into number inputs
$(document).on('input', '.js-phone', function filterNonNumberCharacters() {
  this.value = this.value.replace(/[^0-9]/g, '');
});

// variables
const $submitButton = $('.js-submit');
const $applicationForm = $('.application-form');
const $fullnameInput = $('[name="position_application[name]"]');
const $firstNameInput = $('[name="position_application[first_name]"]');
const $lastNameInput = $('[name="position_application[last_name]"]');
const $emailInput = $('[name="position_application[email]"]');
const $phoneInput = $('[name="position_application[phone]"]');
const $submitErrorMessage = $('.js-form-submit-error-text');
const formContainsFileUpload = false;
const $submitAvailabilityBtn = $('.btn-submit-avaiability');

// prevent submit form by enter 'Enter'
$(document).on(
  'keypress',
  ':input:not(textarea)',
  (event) => event.keyCode !== 13,
);

function clearAllErrors() {
  $('.form-group').removeClass('has-error');
}

const onUploadStateChange = () => updateSubmitButtonState($submitButton, $submitErrorMessage, t);

// validate file input right after user select a file
$('input[type=file]').change(function (e) {
  const { target } = e;
  const fieldName = $(this).attr('name');
  const file = target.files[0] || {};
  const fileSize = file.size;
  const $formItem = $(this).closest('.form-group');
  if (fileSize && fileSize > 500 * 1000000) {
    $formItem.addClass('has-error');
    $formItem
      .find('.error-message')
      .text(t('File size must under 500MB'));
    $(this).val('');
  } else {
    $formItem.removeClass('has-error');
  }
});

// submit form

// submit form will execute automatically after user pass the google recaptcha challenge
// eslint-disable-next-line
window.submitForm = function (token) {
  // disable all the empty file input before create FormData
  // since empty file input will cause HTTP error in Mobile Safari
  // eslint-disable-next-line
  // for (var i = 0; i < questions.length; i+=1) {
  //   var question = questions[i];
  //   var type = question.question_type;
  //   var fieldName = question.name;
  //   if (type === "attachment" || type === "resume") {
  //     var $formItem = $(getInputNameAttributeString(fieldName));
  //     if (!$formItem.val()) {
  //       $formItem.attr("disabled", true);
  //     } else {
  //       // This logic is not for the Mobile Safari bug fix,
  //       // It's a requirement to changing the text 'uploading...' to 'submitting...' when applicant
  //       // didn't submit any files
  //       formContainsFileUpload = true;
  //     }
  //   }
  // }

  // if all field is validate, we need to handle the phone number with the correct country code
  const formData = new FormData($applicationForm[0]);

  for (let i = 0; i < questions.length; i += 1) {
    const question = questions[i];
    const type = question.question_type;
    const fieldName = question.name;
    if (type === 'telephone' && formData.get(fieldName).length > 0) {
      var $formItem = $(getInputNameAttributeString(fieldName));
      const phone = parsePhoneField($formItem);
      if (phone) formData.set(fieldName, phone.number);
    }

    // clear empty optional file upload
    // empty optional file will cause trouble in Mobile Safari Browser
    if (type === 'attachment' || type === 'resume') {
      var $formItem = $(getInputNameAttributeString(fieldName));
      if (!$formItem.val()) {
        $formItem.attr('disabled', false);
      }
    }
  }

  if (isPreview) {
    alert('Successfully submitted in preview mode.');
    return;
  }

  // append the referer data if needed
  if (refererSource) {
    formData.append(
      'position_application[referer_source]',
      decodeURIComponent(refererSource),
    );
  }

  $submitButton.addClass('sending');
  $submitButton.text(t('Submitting'));

  if (window.trackTalentNetwork) {
    window.trackTalentNetwork.submitApply();
  }

  const config = {
    onUploadProgress(progressEvent) {
      const percentCompleted = (
        (progressEvent.loaded / progressEvent.total).toFixed(2) * 100
      ).toFixed(0);
      if (!formContainsFileUpload) {
        $submitButton.text(t('Submitting'));
        return;
      }
      if (percentCompleted !== 100) {
        // $submitButton.text(`Uploading ${percentCompleted}%`);
        $submitButton.text(t('Uploading {{percentCompleted}}', { percentCompleted }));
      } else {
        $submitButton.text(t('Processing files...'));
      }
    },
    headers: {
      locale,
    },
  };
  axios.defaults.headers.common['ws-event-path'] = 'jobs_site';
  axios
    .post(url, formData, config)
    .then((response) => {
      gtag
        && gtag('event', CAREER_PAGE_TRACKING_EVENTS.complete_application_form, {
          send_to: careerPagesGACode,
        });
      if (gtag && window.pixelTrackers) {
        window.pixelTrackers.forEach((measurementId) => {
          gtag('event', CAREER_PAGE_TRACKING_EVENTS.complete_application_form, {
            send_to: measurementId,
          });
        });
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: CAREER_PAGE_TRACKING_EVENTS.complete_application_form,
        });
      }

      $('.js-application-content').addClass('dn');
      $('.js-result-fail').addClass('dn');
      $('.position-title .label').text(
        t('Thank you for applying to the position:'),
      );
      const nextStage = response.data.position_application.next_stage_content;
      if (nextStage !== undefined && nextStage !== null) {
        // $(".js-result-success-next-stage").removeClass("dn");
        $('.js-result-success-next-stage-link').removeClass('dn');
        $('.container-header-text').html(nextStage.greeting_title);
        $('.container-body-text').html(autoLink(nextStage.greeting_body));
        $('.by-the-way-text').html(nextStage.by_the_way);
        if (nextStage.button_link !== null) {
          $('.text-header').html(nextStage.continue_header);
          $('.text-body').html(nextStage.continue_text);
          $('#auto-advance-btn')
            .html(nextStage.button_text)
            .attr(
              'onclick',
              `window.open( '${nextStage.button_link}','_blank' )`,
            )
            .removeClass('dn');
          if (nextStage.stage_type === 'scheduling_stage') {
            checkTimeSlots(nextStage.meeting_digest_key).then((res) => {
              if (res.length) {
                $('.js-result-success-next-stage').removeClass('dn');
                window.open(nextStage.button_link);
              } else {
                $(
                  '.organization-position-apply .js-application-content',
                ).addClass('dn');
                $(
                  '.orgainzation-position-apply-no-timeslots-wrapper',
                ).removeClass('dn');
                // changeCalendarToBlocked(nextStage.meeting_digest_key);
              }
            });
          } else {
            $('.js-result-success-next-stage').removeClass('dn');
          }
        }
      } else {
        $('.js-result-success').removeClass('dn');
        $('.content-wrapper .border-top').addClass('dn');
        $('.js-result-success .border-top').removeClass('dn');
      }
      // set data-applicant to a HTML element, so QA can use it to do further
      // application related testing without going to the HR dashboard to get it.
      if (response && response.data && response.data.position_application) {
        const { id } = response.data.position_application;
        $('body').attr('data-application-id', id);
        if (window.refreshChatbotTooltip) {
          $('#workstream-chatbot-tracking-page').attr('data-tracking-page', 'application-form-apply-success-page');
          window.refreshChatbotTooltip();
        }
      }

      if (typeof isJoinTalentCommunity !== 'undefined' && isJoinTalentCommunity) {
        const talentInfo = _.get(response, 'data.position_application.talent_community_information', _.get(response, 'data.position_application.talent_network_information', {}));
        if (!talentInfo.community_sms_opt_in && !talentInfo.community_email_opt_in) {
          const applicationUuid = _.get(response, 'data.position_application.uuid', '');
          if (window.wsTalentPlugin && applicationUuid) {
            window.wsTalentPlugin.joinTalentCommunity(applicationUuid);
          }
        }
      }
    })
    .catch((error) => {
      const classified = classifySubmitError(error);
      const errorMessage = submitErrorText(classified, t);

      captureStageError(error, classified, {
        page: 'apply',
        locale,
        digestKeyPresent: !!(url && url.indexOf('/positions/') !== -1),
      });

      // A failed challenge has to be reset or the applicant cannot retry at all.
      if (classified.errorCode === 50025 || classified.errorCode === 50051) {
        if (!skipGoogleRecapture) {
          if (grecaptcha) grecaptcha.reset();
        }
      }

      if (classified.errorCode === 40020) {
        // Already applied: the server sends copy that can carry a link, so it is rendered as
        // html here as before.
        $('.js-application-content').addClass('dn');
        $('.js-reapplication-warning').removeClass('dn');
        $('.container-body-text').html(errorMessage);
      } else {
        $submitButton.removeClass('sending');
        $submitButton.addClass('error');
        $submitButton.text(t('Try again'));
        $submitErrorMessage.removeClass('dn');
        $submitErrorMessage.text(errorMessage);
      }

      // Deliberately no rethrow. window.submitForm()'s promise is discarded by its callers, so
      // rethrowing only produced an unhandled rejection -- which is the accidental route by
      // which these failures reached Sentry at all. captureStageError above replaces it, and
      // keeping both would double-report every failure. [MW-2325]
    });
};

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

$submitButton.click((e) => {
  e.preventDefault();

  $submitErrorMessage.addClass('dn');
  $submitButton.removeClass('error');
  clearAllErrors();

  if (isAnyFileUploading()) {
    $submitErrorMessage.removeClass('dn');
    $submitErrorMessage.text(t('Please wait for file upload to complete before submitting.'));
    return;
  }

  const errorNames = [];

  // validate 3 fixed fields
  // - name
  // - email
  // - telephone number

  // - name
  if (_.isEmpty($firstNameInput.val().trim())) {
    $firstNameInput.closest('.form-group').addClass('has-error');
    errorNames.push($firstNameInput.attr('name'));
  }

  if (_.isEmpty($lastNameInput.val().trim())) {
    $lastNameInput.closest('.form-group').addClass('has-error');
    errorNames.push($lastNameInput.attr('name'));
  }

  // - email
  if (!emailRegex.test($emailInput.val())) {
    $emailInput.closest('.form-group').addClass('has-error');
    errorNames.push($emailInput.attr('name'));
  }

  // - telephone number
  const phone = parsePhoneField($phoneInput);
  const isPhoneValid = !!phone && phone.isValid();
  if (!isPhoneValid) {
    errorNames.push($phoneInput.attr('name'));
  } else {
    $phoneInput.val(phone.nationalNumber);
    const $regionInput = $('[name="position_application[region_number]"]');
    $regionInput.val(phone.countryCallingCode);
  }

  // validate candidate info questions

  // take .smartscreen_question as a required question
  $('.smartscreen_question').each(function () {
    const name = $(this).attr('name');
    questions.push({
      question_type: 'multiple_choice',
      is_required: true,
      name,
    });
  });

  const errorMessageMap = {};
  for (let i = 0; i < questions.length; i += 1) {
    const question = questions[i];
    const type = question.question_type;
    const isRequired = question.is_required;
    if (!isRequired) continue;
    const fieldName = question.name;
    const $formItem = $(getInputNameAttributeString(fieldName));

    if (type === 'short_text' || type === 'long_text' || type === 'date') {
      const value = $formItem.val().trim();
      if (value.length === 0) errorNames.push(fieldName);
    }
    if (type === 'attachment' || type === 'resume') {
      const inputValue = $formItem.val();
      if (!inputValue) {
        errorNames.push(fieldName);
        errorMessageMap[fieldName] = t('This is a mandatory field.');
      }
    }
    if (
      type === 'multiple_selection'
      || type === 'multiple_choice'
      || type === 'wotc_questionnaire'
      || type === 'weekly_time_slot'
    ) {
      const value = $formItem.is(':checked');
      if (value === false) errorNames.push(fieldName);
    }
    if (type === 'email') {
      const value = $formItem.val();
      if (value <= 0 || !emailRegex.test(value)) errorNames.push(fieldName);
    }
    if (type === 'telephone') {
      const questionPhone = parsePhoneField($formItem);
      if (!questionPhone || !questionPhone.isValid()) errorNames.push(fieldName);
    }

    if (type === 'dropdown') {
      const value = $formItem.val();
      if (value === null) errorNames.push(fieldName);
    }

    if (type === 'identity') {
      const value = $formItem.val();
      const { country_code: countryCode } = question;
      const { identity_type: identityType } = question;

      if (value.length === 0) {
        errorNames.push(fieldName);
        continue;
      }

      // deal with drive license
      if (
        ['US'].indexOf(countryCode) !== -1
        && ['dl'].indexOf(identityType) !== -1
      ) {
        // get the state user selected
        const selectedStateCode = $formItem
          .closest('.form-group')
          .find('select')
          .val();
        if (!selectedStateCode) {
          errorNames.push(fieldName);
        }
        const regex = getRegularExpression(
          countryCode,
          identityType,
          selectedStateCode,
          appSettings,
        );

        // if no regex founded, just check the existence of the input
        if (!regex && value.length === 0) {
          errorNames.push(fieldName);
          continue;
        }

        const validator = new RegExp(regex);
        if (!validator.test(value.trim())) errorNames.push(fieldName);
      }

      // deal with SSN, NRIC
      if (['ssn', 'nric'].indexOf(identityType) !== -1) {
        const regex = getRegularExpression(
          countryCode,
          identityType,
          undefined,
          appSettings,
        );

        // if no regex founded, just check the existence of the input
        if (!regex && value.length === 0) {
          errorNames.push(fieldName);
          continue;
        }

        const validator = new RegExp(regex);
        if (identityType === 'nric') {
          const upperValue = value.toUpperCase();
          $formItem.val(upperValue);
          if (!validateNRIC(upperValue.trim())) errorNames.push(fieldName);
        } else if (!validator.test(value.trim())) errorNames.push(fieldName);
      }
    }

    // data validation process
    const isDataValidation = question.data_validation;
    if (!isDataValidation) continue;
    const categoryValue = question.rules.category;
    const actionValue = question.rules.action;

    if (categoryValue === 'number') {
      const value = $formItem.val();
      if (!isNumeric(value)) {
        errorNames.push(fieldName);
        errorMessageMap[fieldName] = t('enums:form.errors.number.isNumber', 'Please enter a number');
      } else if (
        actionValue === 'gte'
        && Number(value) < question.rules.value
      ) {
        errorNames.push(fieldName);
        errorMessageMap[fieldName] = t('enums:form.errors.number.gte', 'Please enter a number greater than or equal to {{value}}', question.rules);
      } else if (
        actionValue === 'lte'
        && Number(value) > question.rules.value
      ) {
        errorNames.push(fieldName);
        errorMessageMap[fieldName] = t('enums:form.errors.number.lte', 'Please enter a number less than or equal to {{value}}', question.rules);
      }
    }

    if (categoryValue === 'length') {
      const value = $formItem.val();
      if (value) {
        if (actionValue === 'min' && value.length < question.rules.value) {
          errorNames.push(fieldName);
          errorMessageMap[fieldName] = t(
            'enums:form.errors.length.min',
            'Your response is too short. The minimum character limit is {{value}}',
            question.rules,
          );
        } else if (
          actionValue === 'max'
          && value.length > question.rules.value
        ) {
          errorNames.push(fieldName);
          errorMessageMap[fieldName] = t(
            'enums:form.errors.length.max',
            'Your response is too long. The maximum character limit is {{value}}',
            question.rules,
          );
        }
      }
    }

    if (categoryValue === 'regex') {
      const value = $formItem.val();
      if (value) {
        if (
          actionValue === 'match'
          && !new RegExp(question.rules.value).test(value)
        ) {
          errorNames.push(fieldName);

          errorMessageMap[fieldName] = t(
            'enums:form.errors.regex.match',
            'Please enter a valid response',
            question.rules,
          );
        }
        if (
          actionValue === 'unmatch'
          && new RegExp(question.rules.value).test(value)
        ) {
          errorNames.push(fieldName);

          errorMessageMap[fieldName] = t(
            'enums:form.errors.regex.unmatch',
            'Please enter a valid response',
            question.rules,
          );
        }
      }
    }

    if (categoryValue === 'date') {
      const rawValue = $formItem.val();
      const value = rawValue;
      const userInputDate = new Date(value);
      const ruleDateValue = new Date(question.rules.value);
      const ruleDateMin = new Date(question.rules.min);
      const ruleDateMax = new Date(question.rules.max);
      if (actionValue === 'lt' && userInputDate >= ruleDateValue) {
        errorNames.push(fieldName);

        errorMessageMap[fieldName] = t('enums:form.errors.date.lt', 'Please enter a date before {{value}}', question.rules);
      } else if (
        actionValue === 'lte'
        && new Date(value) > new Date(question.rules.value)
      ) {
        errorNames.push(fieldName);

        errorMessageMap[fieldName] = t('enums:form.errors.date.lte', 'Please enter a date on or before {{value}}', question.rules);
      } else if (actionValue === 'gt' && userInputDate <= ruleDateValue) {
        errorNames.push(fieldName);

        errorMessageMap[fieldName] = t('enums:form.errors.date.gt', 'Please enter a date after {{value}}', question.rules);
      } else if (actionValue === 'gte' && userInputDate < ruleDateValue) {
        errorNames.push(fieldName);

        errorMessageMap[fieldName] = t('enums:form.errors.date.gte', 'Please enter a date on or after {{value}}', question.rules);
      } else if (
        actionValue === 'between'
        && (userInputDate < ruleDateMin || userInputDate > ruleDateMax)
      ) {
        errorNames.push(fieldName);
        errorMessageMap[
          fieldName
        ] = `Please enter a date on or between ${question.rules.min} and ${question.rules.max}`;

        errorMessageMap[fieldName] = t('enums:form.errors.date.between', 'Please enter a date on or between {{min}} and {{max}}', question.rules);
      } else if (
        actionValue === 'unbetween'
        && (userInputDate <= ruleDateMin || userInputDate >= ruleDateMax)
      ) {
        errorNames.push(fieldName);
        errorMessageMap[
          fieldName
        ] = `Please enter a date between ${question.rules.min} and ${question.rules.max}`;

        errorMessageMap[fieldName] = t('enums:form.errors.date.unbetween', 'Please enter a date between {{min}} and {{max}}', question.rules);
      }
    }
  }

  if (errorNames.length > 0) {
    for (let i = 0; i < errorNames.length; i += 1) {
      const fieldName = errorNames[i];
      const $formItem = $(getInputNameAttributeString(fieldName));
      $formItem.closest('.form-group').addClass('has-error');
      if (errorMessageMap[fieldName]) {
        $formItem
          .closest('.form-group')
          .find('.error-message')
          .text(errorMessageMap[fieldName]);
      }

      if (i === 0) {
        $('html, body').animate(
          {
            scrollTop: $formItem.offset().top,
          },
          300,
        );
      }
    }
    return;
  }
  if (skipGoogleRecapture) {
    window.submitForm();
  } else if (grecaptcha) grecaptcha.execute();
});

// helper function to get cookie value
// https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript?answertab=active#tab-top
function C(k) {
  return (document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2];
}

function getRegularExpression(
  countryCode,
  identityType,
  stateCode,
  appSettings,
) {
  const countryInfo = appSettings.identity_regexes.filter(
    (regex) => regex.country_code === countryCode,
  )[0];
  if (!countryInfo) return undefined;

  const identityInfo = countryInfo.identity_types.filter(
    (type) => type.value === identityType,
  )[0];
  if (!identityInfo) return undefined;

  // No state means there is no one more level nested (eg: none drive license identity type)
  if (stateCode === undefined) return identityInfo.regex;

  const stateInfo = identityInfo.states.filter(
    (state) => state.state_code === stateCode,
  )[0];

  if (!stateInfo) return undefined;

  return stateInfo.regex;
}

const initFileFields = () => {
  FilePond.registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);
  const typeNotAllowedLabel = t('This file type is not supported');
  const emptyFileLabel = t('This file is empty');
  const $input = $("input[type='file']").filepond({
    labelIdle: t('Choose file'),
    maxFileSize: '500MB',
    ...fileValidationOptions({
      notAllowedLabel: typeNotAllowedLabel,
      expectedTypesLabel: t('Please upload a document, image, audio or video file'),
      emptyLabel: emptyFileLabel,
      emptyHintLabel: t('Please choose a file that is not empty'),
    }),
    onprocessfilestart: onUploadStateChange,
    onprocessfile: onUploadStateChange,
    onprocessfileabort: onUploadStateChange,
    onremovefile: onUploadStateChange,
    iconRemove: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.175 10.0002L16.425 4.75849C16.5819 4.60157 16.6701 4.38874 16.6701 4.16682C16.6701 3.9449 16.5819 3.73207 16.425 3.57515C16.2681 3.41823 16.0552 3.33008 15.8333 3.33008C15.6114 3.33008 15.3986 3.41823 15.2417 3.57515L9.99999 8.82515L4.75832 3.57515C4.6014 3.41823 4.38857 3.33008 4.16666 3.33008C3.94474 3.33008 3.73191 3.41823 3.57499 3.57515C3.41807 3.73207 3.32991 3.9449 3.32991 4.16682C3.32991 4.38874 3.41807 4.60157 3.57499 4.75849L8.82499 10.0002L3.57499 15.2418C3.49688 15.3193 3.43489 15.4115 3.39258 15.513C3.35027 15.6146 3.32849 15.7235 3.32849 15.8335C3.32849 15.9435 3.35027 16.0524 3.39258 16.154C3.43489 16.2555 3.49688 16.3477 3.57499 16.4252C3.65246 16.5033 3.74463 16.5653 3.84618 16.6076C3.94773 16.6499 4.05665 16.6717 4.16666 16.6717C4.27667 16.6717 4.38559 16.6499 4.48714 16.6076C4.58869 16.5653 4.68085 16.5033 4.75832 16.4252L9.99999 11.1752L15.2417 16.4252C15.3191 16.5033 15.4113 16.5653 15.5128 16.6076C15.6144 16.6499 15.7233 16.6717 15.8333 16.6717C15.9433 16.6717 16.0523 16.6499 16.1538 16.6076C16.2554 16.5653 16.3475 16.5033 16.425 16.4252C16.5031 16.3477 16.5651 16.2555 16.6074 16.154C16.6497 16.0524 16.6715 15.9435 16.6715 15.8335C16.6715 15.7235 16.6497 15.6146 16.6074 15.513C16.5651 15.4115 16.5031 15.3193 16.425 15.2418L11.175 10.0002Z" fill="#787883"/></svg>',
    iconProcess: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4126 2.02586C13.7008 1.35243 13.3897 0.563535 12.6841 0.36692C10.8062 -0.156332 8.80583 -0.121741 6.93209 0.482229C4.63531 1.22256 2.6837 2.76847 1.43725 4.83479C0.190808 6.90111 -0.266394 9.34847 0.14998 11.7254C0.566354 14.1024 1.82822 16.2486 3.70281 17.7682C5.57741 19.2878 7.93828 20.0783 10.35 19.9939C12.7616 19.9094 15.0614 18.9557 16.8251 17.3087C18.5888 15.6617 19.6975 13.4325 19.9466 11.0322C20.1498 9.07405 19.7697 7.10983 18.8693 5.38084C18.5309 4.73117 17.6947 4.59002 17.0955 5.01132C16.4963 5.43262 16.3647 6.25681 16.6716 6.92194C17.2211 8.11308 17.4452 9.43762 17.3081 10.7584C17.1251 12.522 16.3105 14.1599 15.0147 15.37C13.7188 16.5801 12.0291 17.2808 10.2571 17.3429C8.48518 17.4049 6.75056 16.8241 5.37322 15.7076C3.99589 14.5911 3.06875 13.0142 2.76283 11.2677C2.4569 9.5213 2.79283 7.72313 3.70864 6.20493C4.62445 4.68673 6.05836 3.5509 7.7459 3.00694C9.00974 2.59956 10.352 2.54475 11.631 2.83594C12.3453 2.99854 13.1244 2.69929 13.4126 2.02586Z" fill="#2B2D33" fill-opacity="0.24"/></svg>',
    iconRetry: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 9.1665C17 9.1665 16.6667 9.49984 16.6667 9.99984C16.6667 12.4165 15.4167 14.5832 13.3334 15.7498C10.1667 17.5832 6.08335 16.4998 4.25002 13.3332C2.41669 10.1665 3.50002 6.08317 6.66669 4.24984C9.41669 2.6665 12.75 3.24984 14.8334 5.4165H12.8334C12.3334 5.4165 12 5.74984 12 6.24984C12 6.74984 12.3334 7.08317 12.8334 7.08317H16.5834C17.0834 7.08317 17.4167 6.74984 17.4167 6.24984V2.49984C17.4167 1.99984 17.0834 1.6665 16.5834 1.6665C16.0834 1.6665 15.75 1.99984 15.75 2.49984V3.99984C14.1667 2.49984 12.1667 1.6665 10 1.6665C5.41669 1.6665 1.66669 5.4165 1.66669 9.99984C1.66669 14.5832 5.41669 18.3332 10 18.3332C14.5834 18.3332 18.3334 14.5832 18.3334 9.99984C18.3334 9.49984 18 9.1665 17.5 9.1665Z" fill="#787883"/></svg>',
    server: {
      process(fieldName, file, metadata, load, error, progress, abort, transfer, options) {
        const tokenRequest = new XMLHttpRequest();
        const fetchPresignedUrl = `${APIHOST}/v1/uploads/fetch_presigned_object?upload_type=application_attachment&filename=${file.name}`;
        tokenRequest.open('POST', fetchPresignedUrl, { filename: file.name });
        let s3Request = null;
        tokenRequest.onload = () => {
          const json = JSON.parse(tokenRequest.responseText);
          const preSignedUrl = json.presigned_url;
          const applicationAttachmentId = json.asset && json.asset.id;

          s3Request = new XMLHttpRequest();
          s3Request.open('PUT', preSignedUrl);
          s3Request.setRequestHeader('Content-Type', file.type);

          s3Request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
          };

          s3Request.onload = () => {
            if (s3Request.status >= 200 && s3Request.status < 300) {
              // load(s3Request.responseText)
              load(applicationAttachmentId);
            } else {
              error(s3Request.responseText);
            }
          };

          s3Request.send(file);
        };
        tokenRequest.send();

        return {
          abort: () => {
            if (tokenRequest) tokenRequest.abort();
            if (s3Request) s3Request.abort();

            abort();
          },
        };
      },
      revert: null,
      remove: null,
    },
  });
  const filePondInstance = FilePond.find($input[0]);
  const captureFilePondError = (error) => {
    if (typeof Sentry !== 'undefined' && Sentry.captureException) {
      Sentry.captureException(error, {
        level: 'error',
        extra: {
          message: error && error.message,
          useragent: navigator.userAgent,
        },
      });
    }
  };
  if (!FilePond.supported()) {
    captureFilePondError(new Error('FilePond is not supported in this browser'));
  }
  if (filePondInstance) {
    filePondInstance.on('error', (error) => {
      if (error && [typeNotAllowedLabel, emptyFileLabel].includes(error.main)) return;
      captureFilePondError(error);
    });
  }
};
